/* eslint-disable @typescript-eslint/no-unused-expressions */
import { CommonModule, Location } from "@angular/common";
import {
    Component,
    computed,
    ElementRef,
    inject,
    viewChild,
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { Icon } from "@malirang/front-share";

@Component({
    selector: "app-my-page-layout",
    standalone: true,
    imports: [CommonModule, RouterModule, Icon],
    templateUrl: "./layout.page.html",
    styleUrl: "./layout.page.scss",
})
export default class MyPageLayoutPage {
    readonly router = inject(Router);
    readonly location = inject(Location);

    platform = Capacitor.getPlatform();
    header = viewChild<ElementRef>("header");
    headerHeight = computed(
        () => this.header()?.nativeElement?.offsetHeight || 0,
    );

    goBack() {
        this.router.navigate(["/schedule"]);
    }
}
